<div class="page-container" style="min-height:188.38330078125px">
  <div class="page-content">
    <div class="panel panel-default shadow" style="border: none">
      <div class="panel-heading">
        <h4 class="panel-title" translate>Plan Info</h4>
      </div>
      <div class="panel-body">
        <div class="row">
            <table class="table table-sm table-borderless">
              <thead></thead>
              <tbody>
              <tr>
                <th class="col-md-3 col-sm-3" style="text-align: right" translate><strong>Plan:</strong></th>
                <td class="col-md-5 col-sm-5">{{translate.instant(userSubscription?.plan?.name)}}</td>
                <td class="col-md-4 col-sm-4"  style="text-align: center"><button type="button" class="btn btn-xs btn-primary" (click)="changePlan()" translate>Change Plan</button></td>
              </tr>
              </tbody>
            </table>
            <div *ngIf="isPaidPlan && !isCancelPending">
              <p class="text-justify" translate [innerHTML]="'RENEWAL_SUBSCRIPTION' | translate:{price:planUpgradePrice,currency:planUpgradeCurrency,date:formatDate(planRenewalDate)}"></p>
            </div>
        </div>
      </div>
    </div>

    <div *ngIf="isPaidPlan && !isPendingDeletion" class="panel panel-default shadow" style="border: none">
      <div class="panel-heading">
        <h4 class="panel-title" translate>Subscription</h4>
      </div>
      <div class="panel-body">
        <div class="row">
          <table class="table table-sm table-borderless">
            <tbody>
            <tr *ngIf="!isCancelPending">
              <td class="col-md-8 col-sm-8" translate>CANCEL_SUBSCRIPTION_EXPLAIN</td>
              <td class="col-md-4 col-sm-4" style="text-align: center">
                <button id="cancelSubscriptionButton" type="button" class="btn btn-xs btn-danger"
                        [disabled]="actionInProgress" (click)="cancelSubscription()" translate>Cancel subscription</button>
              </td>
            </tr>
            <tr *ngIf="isCancelPending">
              <td class="col-md-8 col-sm-8" [innerHTML]="'SUBSCRIPTION_CANCELLED_STATE' | translate:{date:formatDate(effectiveEndDate)}"></td>
              <td class="col-md-4 col-sm-4" style="text-align: center">
                <button id="resumeSubscriptionButton" type="button" class="btn btn-xs btn-primary"
                        [disabled]="actionInProgress" (click)="resumeSubscription()" translate>Resume subscription</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div id="accountDeletionPanel" class="panel panel-default shadow" style="border: none">
      <div class="panel-heading">
        <h4 class="panel-title" translate>Account deletion</h4>
      </div>
      <div class="panel-body">
        <div *ngIf="isPendingDeletion" id="deletionPendingBanner" class="alert alert-danger">
          <p [innerHTML]="'DELETION_PENDING_BANNER' | translate:{date:formatDate(accountDeletion?.deletionDate)}"></p>
          <p translate>DELETION_PENDING_SUPPORT</p>
          <button id="abortDeletionButton" type="button" class="btn btn-xs btn-primary"
                  [disabled]="actionInProgress" (click)="abortDeletion()" translate>Cancel deletion request</button>
        </div>
        <div *ngIf="!isPendingDeletion" class="row">
          <table class="table table-sm table-borderless">
            <tbody>
            <tr>
              <td colspan="2" translate>DELETE_ACCOUNT_EXPLAIN</td>
            </tr>
            <tr>
              <td class="col-md-8 col-sm-8">
                <span *ngIf="!deleteAccountAvailable" class="text-muted" translate>DELETE_ACCOUNT_GATE_CLOSED</span>
              </td>
              <td class="col-md-4 col-sm-4" style="text-align: center">
                <button id="deleteAccountButton" type="button" class="btn btn-xs btn-danger"
                        [disabled]="!deleteAccountAvailable || actionInProgress" (click)="deleteAccount()" translate>Delete account</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div *ngIf="paymentMethod != 'STRIPE'" class="panel panel-default shadow" style="border: none">
      <div class="panel-heading">
        <h4 class="panel-title" translate>Card and Invoice Info</h4>
      </div>
      <div class="panel-body">
        <div class="row">
            <table class="table table-sm table-borderless">
              <thead></thead>
              <tbody>
              <tr>
                <th class="col-md-3 col-sm-3" style="text-align: right"><strong translate>Registered Credit Card:</strong></th>
                <td class="col-md-5 col-sm-5">XXXX XXXX XXXX {{userSubscription?.cardLastNo}}</td>
                <td class="col-md-4 col-sm-4" style="text-align: center"><button type="button" class="btn btn-xs btn-primary" (click)="updateCardInvoiceInfo()" data-toggle="modal" data-target="#modal_payment" translate>Update Card and Invoice Info</button></td>
              </tr>
              <tr>
                <th class="col-md-3 col-sm-3" style="text-align: right"><strong translate>Invoice Address</strong></th>
                <td class="col-md-5 col-sm-5">
                  <p>
                    {{authorization?.userAccount?.subscription?.invoiceAddress}}
                    <br>
                    {{authorization?.userAccount?.subscription?.invoiceCity}}
                  </p>
                </td>
                <td class="col-md-4 col-sm-4"></td>
              </tr>
              </tbody>
            </table>
        </div>
      </div>
    </div>
    <div *ngIf="paymentMethod == 'STRIPE'" class="panel panel-default shadow" style="border: none">
      <div class="panel-heading">
        <h4 class="panel-title" translate>Payment Management</h4>
      </div>
      <div class="panel-body">
        <div class="row">
            <table class="table table-sm table-borderless">
              <thead></thead>
              <tbody>
              <tr>
                <th class="col-md-4 col-sm-4" style="text-align: right"><strong translate>Payment Method:</strong></th>
                <td class="col-md-4 col-sm-4" translate>Managed by Stripe</td>
                <td class="col-md-4 col-sm-4" style="text-align: center">
                  <button type="button" class="btn btn-xs btn-primary" (click)="openStripePortal()" translate>Manage Payment & Invoices</button>
                </td>
              </tr>
              </tbody>
            </table>
        </div>
      </div>
    </div>
    <div class="panel panel-default shadow" style="border: none">
      <div class="panel-heading">
        <h4 class="panel-title" translate>Transaction History</h4>
      </div>
      <div class="panel-body">
        <table class="table table-sm table-bordered table-striped">
          <thead>
            <tr>
              <th translate>INVOICE</th>
              <th translate>OPERATION NO</th>
              <th translate>PROCESS DATE</th>
              <th translate>EXPLANATION</th>
              <th translate>PAYMENT METHOD</th>
              <th translate>AMOUNT</th>
            </tr>
          </thead>
          <tbody>
           <!-- <tr *ngFor="let transaction of transactions;" role="row" class="odd">
              <td>{{}}</td>
              <td>{{}}</td>
              <td>{{}}</td>
              <td>{{}}</td>
              <td>{{}}</td>
              <td>{{}}</td>
            </tr>-->
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div *ngIf="paymentModalVisibility && paymentMethod != 'STRIPE'">
  <sd-payment [action]="paymentAction"></sd-payment>
</div>

